module.exports = __webpack_public_path__ + "img/melia-pool-2.23b6a796.jpg";